import { createContext } from 'react';

/*
Destination context provides destination details (id, name, heroImage, description, menu items etc.)
to all components. The data is fetched server-side in the root route loader and passed into this context.

Analytics initialization is handled by the router observer in Analytics.jsx.
*/

export const DestinationContext = createContext();
